import { Box, Link, Stack } from "@mui/material";
import { RecoveryFlow, UpdateRecoveryFlowBody } from "@ory/kratos-client";
import { UiForm } from "../../../components";

export interface RecoveryFormProps {
  flow: RecoveryFlow;
  onAttemptRecovery: (values: UpdateRecoveryFlowBody) => Promise<void>;
}

export const RecoveryForm: React.FC<RecoveryFormProps> = ({
  flow,
  onAttemptRecovery,
}) => {
  return (
    <>
      <Stack spacing={4}>
        <UiForm
          handleSubmit={onAttemptRecovery}
          ui={flow.ui}
          groups={["code"]}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        />
      </Stack>
      <Box sx={{ marginTop: "16px", textAlign: "center" }}>
        <Link
          href="/login"
          sx={(theme) => ({
            color: theme.palette.grey[600],
            fontSize: "14px",
            fontWeight: 700,
            textDecoration: "none",
            "&:hover": {
              color: theme.palette.grey[800],
              textDecoration: "underline",
            },
          })}
        >
          Povratak na prijavu
        </Link>
      </Box>
    </>
  );
};
